import { render, staticRenderFns } from "./VisibilityMatrixTable.vue?vue&type=template&id=0d8acc04&"
import script from "./VisibilityMatrixTable.vue?vue&type=script&lang=js&"
export * from "./VisibilityMatrixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports